module.exports = __webpack_public_path__ + "static/media/nn-banner-checkout-left.d83e6dd0.png";